module.exports = __webpack_public_path__ + "img/logo_kemp.05123029.png";